(function () {
  document.querySelectorAll('.orotech-pm').forEach(function (sectionEl) {

    // Gallery thumbnails — sync main image + dots
    sectionEl.querySelectorAll('[data-gallery]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var galleryId = btn.dataset.gallery;
        var mainImg   = document.getElementById('orotech-main-img-' + galleryId);
        var dotsEl    = document.getElementById('orotech-dots-' + galleryId);
        if (mainImg) mainImg.src = btn.dataset.src;
        sectionEl.querySelectorAll('[data-gallery="' + galleryId + '"]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        if (dotsEl) {
          var idx = parseInt(btn.dataset.index || 0, 10);
          dotsEl.querySelectorAll('.orotech-pm__gallery-dot').forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        }
      });
    });

    // Zoom lightbox
    sectionEl.querySelectorAll('[data-zoom]').forEach(function (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var id      = zoomBtn.dataset.zoom;
        var overlay = document.getElementById('orotech-zoom-' + id);
        var img     = document.getElementById('orotech-zoom-img-' + id);
        var mainImg = document.getElementById('orotech-main-img-' + id);
        if (!overlay || !img || !mainImg) return;
        img.src = mainImg.src;
        img.alt = mainImg.alt;
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    sectionEl.querySelectorAll('[data-zoom-close]').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', closeZoom);
    });
    sectionEl.querySelectorAll('.orotech-pm__zoom-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeZoom();
      });
    });
    function closeZoom() {
      sectionEl.querySelectorAll('.orotech-pm__zoom-overlay').forEach(function (o) {
        o.hidden = true;
      });
      document.body.style.overflow = '';
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
    });

    // Qty stepper
    sectionEl.querySelectorAll('.orotech-pm__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.orotech-pm__qty-ctrl').querySelector('.orotech-pm__qty-input');
        if (!input) return;
        var cur = parseInt(input.value, 10) || 1;
        if (btn.dataset.qtyAction === 'inc') {
          input.value = cur + 1;
        } else {
          input.value = Math.max(1, cur - 1);
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Share button — use Web Share API with clipboard fallback
    sectionEl.querySelectorAll('.orotech-pm__share-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url   = btn.dataset.shareUrl;
        var title = btn.dataset.shareTitle;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var orig = btn.textContent;
            btn.textContent = 'Nukopijuota!';
            setTimeout(function () { btn.textContent = orig; }, 2000);
          });
        }
      });
    });

    // Sticky button delegates to the native ATC button so product-form-component handles submission
    sectionEl.querySelectorAll('.orotech-pm__sticky-btn').forEach(function (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var addBtn = sectionEl.querySelector('form [name="add"]');
        if (addBtn) addBtn.click();
      });
    });

    // Variant picker
    sectionEl.querySelectorAll('.orotech-pm__option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.orotech-pm__option-values').querySelectorAll('.orotech-pm__option-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var form = btn.closest('form');
        if (!form) return;

        var selectedValues = [];
        form.querySelectorAll('.orotech-pm__option-values').forEach(function (group) {
          var sel = group.querySelector('.is-selected');
          selectedValues.push(sel ? sel.dataset.value : '');
        });

        var productData = window.__orotech_product_data;
        if (!productData) return;

        var matched = productData.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedValues[i]; });
        });

        if (!matched) return;

        form.querySelector('[name="id"]').value = matched.id;

        var formatted = (matched.price / 100).toLocaleString('lt-LT', { style: 'currency', currency: 'EUR' });

        // Update main ATC button
        var atcBtn = form.querySelector('.orotech-pm__atc-btn');
        if (atcBtn) {
          if (matched.available) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('is-disabled');
            atcBtn.querySelector('span:first-child').textContent = 'Į krepšelį';
            var priceEl = atcBtn.querySelector('.orotech-pm__atc-price');
            if (priceEl) priceEl.textContent = formatted;
          } else {
            atcBtn.disabled = true;
            atcBtn.classList.add('is-disabled');
            atcBtn.querySelector('span:first-child').textContent = 'Laikinai nėra';
          }
        }

        // Update sticky bar
        var stickyBtn = sectionEl.querySelector('.orotech-pm__sticky-btn');
        var stickyPrice = sectionEl.querySelector('.orotech-pm__sticky-price');
        var stickyStock = sectionEl.querySelector('.orotech-pm__sticky-stock');
        if (stickyPrice) stickyPrice.textContent = formatted;
        if (stickyBtn) {
          stickyBtn.disabled = !matched.available;
          stickyBtn.classList.toggle('is-disabled', !matched.available);
        }
        if (stickyStock) {
          if (matched.available) {
            stickyStock.textContent = 'Sandėlyje';
            stickyStock.className = 'orotech-pm__sticky-stock orotech-pm__sticky-stock--in';
          } else {
            stickyStock.textContent = 'Laikinai nėra';
            stickyStock.className = 'orotech-pm__sticky-stock orotech-pm__sticky-stock--out';
          }
        }
      });
    });

  });
})();

/* ── Price guarantee modal ── */
(function () {
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-modal-open]');
    if (openBtn) {
      var id = openBtn.getAttribute('data-modal-open');
      var modal = document.getElementById(id);
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    var closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      var id = closeBtn.getAttribute('data-modal-close');
      var modal = document.getElementById(id);
      if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.orotech-pm__pg-modal:not([hidden])').forEach(function (m) {
        m.hidden = true; document.body.style.overflow = '';
      });
    }
  });
})();
